import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaMapMarkerAlt, FaEnvelope, FaInstagram, FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import clinicaConfig from "../../clinicaConfig.js";
import logosvg from '../Assets/logo.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-coluna footer-logo-coluna">
          <Link to='/' className="footer-logo-link">
            <img src={logosvg} alt="Logo da Clínica" className="footer-logo" />
          </Link>
          <p className="footer-descricao">Cuidando da sua saúde com excelência e dedicação.</p>
        </div>

        <div className="footer-coluna footer-contatos-coluna">
          <h3 className="footer-titulo-coluna">Contatos</h3>
          <div className="footer-contatos">
            <a href="https://www.google.com/maps/place/Cl%C3%ADnica+Samec+De+Canudos/@-9.8964942,-39.0274852,1534m/data=!3m2!1e3!4b1!4m6!3m5!1s0x70c49006efa6001:0x8579e6dd1ce540cb!8m2!3d-9.8964942!4d-39.0274852!16s%2Fg%2F11yyf6jtkf?entry=ttu&g_ep=EgoyMDI2MDIwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer" className="footer-contato-item footer-contato-link">
              <FaMapMarkerAlt className="footer-icone" />
              <span>{clinicaConfig.EnderecoCompleto()}</span>
            </a>
            <a href={`https://wa.me/${clinicaConfig.whatsapp}`} target="_blank" rel="noreferrer" className="footer-contato-item footer-contato-link">
              <FaWhatsapp className="footer-icone" />
              <span>{clinicaConfig.whatsappFormatado}</span>
            </a>
            <a href={`mailto:${clinicaConfig.email}`} className="footer-contato-item footer-contato-link">
              <FaEnvelope className="footer-icone" />
              <span>{clinicaConfig.email}</span>
            </a>
          </div>
        </div>

        <div className="footer-coluna footer-mapa">
          <h3 className="footer-titulo-coluna">Navegação</h3>
          <ul className="footer-links">
            <li><Link to='/Lista-de-exames'>Nossos Exames</Link></li>
            <li><Link to='/todos-medicos'>Nossos Médicos</Link></li>
            <li><Link to='/resultados-exames'>Resultados</Link></li>
          </ul>
        </div>

        <div className="footer-coluna footer-sobre">
          <h3 className="footer-titulo-coluna">Sobre</h3>
          <ul className="footer-links">
            <li><a href="/sobre">Sobre a {clinicaConfig.nomeClinica}</a></li>
            <li><a href="/importancia-da-saude">Por que se Cuidar?</a></li>
          </ul>
        </div>

        <div className="footer-coluna footer-social">
          <h3 className="footer-titulo-coluna">Redes Sociais</h3>
          <p className="footer-social-texto">Siga-nos e fique por dentro das novidades</p>
          <div className="footer-social-icones">
            <a href={`https://www.instagram.com/${clinicaConfig.instagram}`} target="_blank" rel="noreferrer" aria-label="Instagram" className="footer-social-link instagram">
              <FaInstagram />
            </a>
            <a href={`https://www.facebook.com/${clinicaConfig.facebook}`} target="_blank" rel="noreferrer" aria-label="Facebook" className="footer-social-link facebook">
              <FaFacebookF />
            </a>
            <a href={`https://wa.me/${clinicaConfig.whatsapp}`} target="_blank" rel="noreferrer" aria-label="Whatsapp" className="footer-social-link whatsapp">
              <FaWhatsapp />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-copyright">
        <p>&copy; {new Date().getFullYear()} {clinicaConfig.nomeClinica}. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;